// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-2a2760a4] button{font-weight:700}*[data-v-2a2760a4] button,*[data-v-2a2760a4] h3,*[data-v-2a2760a4] h4{font-family:Open Sans,sans-serif!important}*[data-v-2a2760a4] h3,*[data-v-2a2760a4] h4{color:var(--c-black);line-height:normal}*[data-v-2a2760a4] h3{font-weight:700}*[data-v-2a2760a4] h4{font-size:15px;margin-bottom:2px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
